module.exports = __webpack_public_path__ + "static/media/delete_icon.968919c0.svg";